module.exports = __webpack_public_path__ + "img/face-mask.f47a52d0.svg";